import React from "react";
import "./Footer.css";
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaLinkedin,
  FaPinterest,
  FaTwitter,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-section about">
        <img src="Logo.png" alt="Aruna Hospital Logo" className="logo" />
        <p>
          In memory of Dr. Kanakamedala Rangarao, this institution was
          established in 1976 by his son and daughter-in-law, Smt. Kasturi Garu
          and Sri Pinnamaneni Chandramohan Garu. Smt. Kasturi Garu earned great
          respect for her dedicated service in obstetrics. Sri Pinnamaneni
          Chandramohan Garu served as Secretary of the Indian Medical
          Association and organized several medical camps. Their continued
          contributions have played a vital role in the growth of the Rotary
          Hospital and Rotary Vanaprastha.
        </p>
        <div className="social-icons">
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebook />
          </a>
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram />
          </a>
          <a
            href="https://youtube.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaYoutube />
          </a>
          <a
            href="https://linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin />
          </a>
          <a
            href="https://pinterest.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaPinterest />
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTwitter />
          </a>
        </div>
      </div>

      <div className="footer-section menu">
        <h4>Our Menu</h4>
        <ul>
          <li>→ Home</li>
          <li>→ About</li>
          <li>→ Doctors</li>
          <li>→ Departments</li>
          <li>→ Contact</li>
        </ul>
      </div>

      <div className="footer-section contact">
        <h4>Reach Us</h4>
        <p>
          <FaMapMarkerAlt /> Katuru Rd, Vuyyuru, <br />
          Andhra Pradesh - 521165
        </p>
        <p>
          <FaPhone /> +91 9441246269 <br /> 086762 32040
        </p>
        <p>
          <FaEnvelope /> Contact@pinnamanenihospital.com
        </p>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <div className="copyright">
            &copy; <strong>Pinnamaneni Hospital</strong>. All Rights Reserved |
            Designed by{" "}
            <a
              className="company-name"
              href="https://vistoramarketing.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Vistora Marketing Solutions
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
